import { useState } from "react";
import { ListPage } from "@/archetypes/ListPage";
import { TasksSummaryWidget } from "@/components/tasks/TasksSummaryWidget";

type SummaryScope = "mine" | "all";

export function TasksSummaryPage() {
  const [scope, setScope] = useState<SummaryScope>("mine");

  const toggle = (
    <div className="inline-flex bg-blue-50/80 p-1 rounded-lg">
      <button
        type="button"
        onClick={() => setScope("mine")}
        className={`px-4 py-1.5 text-sm font-medium rounded-md transition-all duration-200 ${
          scope === "mine"
            ? "bg-[#0f3453] text-white shadow-sm"
            : "text-blue-900/60 hover:text-blue-900 hover:bg-blue-100/50"
        }`}
      >
        Mine
      </button>
      <button
        type="button"
        onClick={() => setScope("all")}
        className={`px-4 py-1.5 text-sm font-medium rounded-md transition-all duration-200 ${
          scope === "all"
            ? "bg-[#0f3453] text-white shadow-sm"
            : "text-blue-900/60 hover:text-blue-900 hover:bg-blue-100/50"
        }`}
      >
        All
      </button>
    </div>
  );

  return (
    <ListPage title="Tasks Summary" backTo="/tasks" primaryAction={toggle}>
      <TasksSummaryWidget scope={scope} />
    </ListPage>
  );
}
